module.exports = __webpack_public_path__ + "static/media/pmt_view-payment-adjustment-submissions.247be4c8.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/pmt_view-payment-adjustment-submissions.md
// module id = 1106
// module chunks = 0